export default {
  bind(el, binding) {
    // 为每个元素创建唯一的水印标识
    const watermarkId = `watermark_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`
    el._watermarkId = watermarkId
    createWatermark(el, binding, watermarkId)
  },

  componentUpdated(el, binding) {
  // 当绑定值发生变化时更新水印内容
    if (JSON.stringify(binding.value) !== JSON.stringify(binding.oldValue)) {
    // 如果水印元素存在则更新内容，否则重新创建
      const watermarkDiv = el.querySelector(`[data-watermark-id="${el._watermarkId}"]`)
      if (watermarkDiv) {
        updateWatermarkContent(el, binding, el._watermarkId)
      } else {
      // 重新生成唯一ID并创建新的水印
        const newWatermarkId = `watermark_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`
        el._watermarkId = newWatermarkId
        createWatermark(el, binding, newWatermarkId)
      }
    }
  },

  unbind(el) {
    // 解绑时清理水印及监听器
    if (el._watermarkId) {
      clearWatermarkById(el, el._watermarkId)
      delete el._watermarkId
    }
  }
}

// 清理水印元素及监听器
function clearWatermarkById(el, watermarkId) {
  if (!watermarkId) return

  // 查找水印容器
  const watermarkDiv = el.querySelector(`[data-watermark-id="${watermarkId}"]`)
  if (watermarkDiv) {
    // 停止观察器
    if (watermarkDiv._observer) {
      watermarkDiv._observer.disconnect()
    }
    // 移除水印元素
    if (watermarkDiv.parentNode) {
      watermarkDiv.parentNode.removeChild(watermarkDiv)
    }
  }
}

// 创建水印（初始化时调用）
function createWatermark(el, binding, watermarkId) {
  // 获取配置参数
  const options = getWatermarkOptions(binding)
  const { paddingX, paddingY } = parsePadding(options.padding)

  // 创建水印容器（复用DOM）
  const watermarkDiv = document.createElement('div')
  watermarkDiv.setAttribute('data-watermark-id', watermarkId)
  watermarkDiv._isWatermarkElement = true
  watermarkDiv.style.cssText = `
    pointer-events: none;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 999;
    background-repeat: repeat;
    will-change: background-image;
    backface-visibility: hidden;
    transform: translateZ(0);
    transition: background-image 0.2s ease-out;
  `

  // 设置父元素为相对定位
  if (window.getComputedStyle(el).position === 'static') {
    el.style.position = 'relative'
  }

  // 创建隐藏的canvas（复用绘制）
  const canvas = document.createElement('canvas')
  canvas.style.display = 'none'
  watermarkDiv.appendChild(canvas)

  // 绘制水印并设置背景
  updateCanvasContent(canvas, options)
  const newText = Array.isArray(options.text) ? options.text.join('\n') : options.text
  if (canvas._lastText === newText) return

  canvas._lastText = newText
  const { gapX, gapY } = parseDensity(options.density)
  watermarkDiv.style.backgroundSize = `${gapX + paddingX * 2}px ${gapY + paddingY * 2}px`
  watermarkDiv.style.backgroundImage = `url(${canvas.toDataURL()})`

  // 添加水印到目标元素
  el.appendChild(watermarkDiv)

  // 监听水印是否被移除（防抖处理）
  let isRestoring = false
  const observer = new MutationObserver(() => {
    if (!isRestoring && !el.contains(watermarkDiv) && el._watermarkId === watermarkId) {
      isRestoring = true
      // 微任务中执行，避免频繁触发
      Promise.resolve().then(() => {
        el.appendChild(watermarkDiv)
        isRestoring = false
      })
    }
  })
  observer.observe(el, { childList: true, subtree: false })
  watermarkDiv._observer = observer // 保存观察器引用，用于解绑时清理
}

// 更新水印内容（复用现有DOM和canvas）
function updateWatermarkContent(el, binding, watermarkId) {
  const watermarkDiv = el.querySelector(`[data-watermark-id="${watermarkId}"]`)
  if (!watermarkDiv) return

  // 获取最新配置
  const options = getWatermarkOptions(binding)
  const { paddingX, paddingY } = parsePadding(options.padding)
  const { gapX, gapY } = parseDensity(options.density)

  // 复用现有canvas更新内容
  const canvas = watermarkDiv.querySelector('canvas')
  if (canvas) {
    updateCanvasContent(canvas, options)
    watermarkDiv.style.backgroundSize = `${gapX + paddingX * 2}px ${gapY + paddingY * 2}px`
    watermarkDiv.style.backgroundImage = `url(${canvas.toDataURL()})`
  }
}

// 解析水印配置参数（默认值处理）
function getWatermarkOptions(binding) {
  return {
    text: '',
    color: 'rgba(180, 180, 180, 0.3)',
    fontSize: '14px',
    rotate: -15,
    density: [100, 100],
    padding: [20, 20],
    lineHeight: 20,
    ...binding.value
  }
}

// 解析padding参数
function parsePadding(padding) {
  return Array.isArray(padding)
    ? { paddingX: padding[0], paddingY: padding[1] }
    : { paddingX: padding, paddingY: padding }
}

// 解析density参数
function parseDensity(density) {
  return Array.isArray(density)
    ? { gapX: density[0], gapY: density[1] }
    : { gapX: density, gapY: density }
}

// 更新canvas内容（核心绘制逻辑）
function updateCanvasContent(canvas, options) {
  const { text, color, fontSize, rotate, padding, lineHeight } = options
  const { paddingX, paddingY } = parsePadding(padding)

  // 处理多行文字
  const lines = Array.isArray(text) ? text : text.split('\n')
  if (lines.length === 0) return

  // 获取canvas上下文
  const ctx = canvas.getContext('2d')
  ctx.clearRect(0, 0, canvas.width, canvas.height) // 清空画布

  // 设置字体
  ctx.font = `${fontSize} Arial`
  ctx.fillStyle = color
  ctx.textAlign = 'center'
  ctx.textBaseline = 'middle'

  // 计算文字尺寸
  let maxWidth = 0
  lines.forEach(line => {
    const lineWidth = ctx.measureText(line).width
    if (lineWidth > maxWidth) maxWidth = lineWidth
  })
  const textHeight = Math.abs(ctx.measureText('M').actualBoundingBoxAscent) +
                    Math.abs(ctx.measureText('M').actualBoundingBoxDescent)
  const totalTextHeight = lines.length * textHeight + (lines.length - 1) * lineHeight

  // 计算旋转后的画布尺寸
  const angle = Math.abs(rotate) * Math.PI / 180
  const canvasWidth = Math.abs(maxWidth * Math.cos(angle)) + Math.abs(totalTextHeight * Math.sin(angle))
  const canvasHeight = Math.abs(maxWidth * Math.sin(angle)) + Math.abs(totalTextHeight * Math.cos(angle))

  // 设置canvas尺寸（添加内边距）
  canvas.width = canvasWidth + 50 + paddingX * 2
  canvas.height = canvasHeight + 50 + paddingY * 2

  // 重新设置字体（尺寸变化后需重新设置）
  ctx.font = `${fontSize} Arial`
  ctx.fillStyle = color
  ctx.textAlign = 'center'
  ctx.textBaseline = 'middle'

  // 绘制文字（旋转处理）
  ctx.translate(canvas.width / 2, canvas.height / 2)
  ctx.rotate((Math.PI / 180) * rotate)

  // 绘制每行文字
  const startY = -(totalTextHeight / 2) + (textHeight / 2)
  lines.forEach((line, index) => {
    const y = startY + index * (textHeight + lineHeight)
    ctx.fillText(line, 0, y)
  })
}
